import { useEffect, useState } from "react";
import { useAppOrgContext } from "../../../context/AppOrgContext";
import { useAxiosContext } from "../../../context/AxiosContext";
import { useFormContext } from "../../../context/FormContext";
import { createChecksum } from "../../../commonFunctions/fileFolderConfig";
import Loader from "../../../Layouts/Loader/Loader";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import Textarea from "../../../components/FormComponents/Textarea";
import { useNavigate, useParams } from "react-router-dom";
import { toastSuccess } from "../../../utils/toastUtils";
import { getFolderFileById } from "../../../utils/treeData/folderEditorUtils";
import { useTreeContext } from "../../../context/TreeDataContext";

const CustomFunction = () => {
  const { customFuncData, setCustomFuncData, setSelectedForm } = useFormContext();
  const { axiosInstance, handleError } = useAxiosContext();
  const { currentChecksum } = useAppOrgContext();
  const [isLoader, setIsLoader] = useState(false);
  const { functionId } = useParams();
  const navigate = useNavigate();
  const { formsExplorerData } = useTreeContext();

  const handleChangeTemplate = (e) => {
    setCustomFuncData({ ...customFuncData, [e.target.name]: e.target.value });
  };

  const fetchCustomFunction = async () => {
    try {
      setIsLoader(true);
      const { data } = await axiosInstance.get(`/custom_function/${functionId}`);
      const { body } = data;
      setCustomFuncData({ body: body });
      currentChecksum.current = createChecksum({ body: body });
      setIsLoader(false);
    } catch (error) {
      handleError(error);
      setIsLoader(false);
    }
  };

  const handleSaveCustomFunction = async () => {
    try {
      const { message } = await axiosInstance.patch(`/custom_function/${functionId}`, customFuncData);
      toastSuccess(message);
    } catch (error) {
      handleError(error);
    }
  };

  const initialRendering = async () => {
    const fileId = `customfunction/${functionId}`;
    const file = getFolderFileById(formsExplorerData, fileId);
    if (file) {
      setSelectedForm({
        id: fileId,
        name: file.name,
        parentData: file.parentData,
        type: file.type
      });
    } else {
      navigate("../");
    }
  };

  useEffect(() => {
    initialRendering();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [functionId]);

  useEffect(() => {
    fetchCustomFunction();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [functionId]);

  if (isLoader) return <Loader />;

  return (
    <div className={"w_100"}>
      <PageInfoAndActionBar
        // pagePath={`${selectedForm.parentData}/${selectedForm.name}`}
        savePage={handleSaveCustomFunction}
        currentConfig={[customFuncData]}
        pageName="form"
      />
      <div className="page_main_section">
        <Textarea
          label="Enter Custom Function"
          value={customFuncData.body}
          name="body"
          rows={"30"}
          onChange={handleChangeTemplate}
        />
      </div>
    </div>
  );
};

export default CustomFunction;
